import { render, staticRenderFns } from "./resourcelinks.vue?vue&type=template&id=f196c380"
import script from "./resourcelinks.vue?vue&type=script&lang=js"
export * from "./resourcelinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports